/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminEbaySellingLimitResp
 */
export interface AdminEbaySellingLimitResp {
    /**
     * 
     * @type {number}
     * @memberof AdminEbaySellingLimitResp
     */
    amountLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminEbaySellingLimitResp
     */
    amountRemaining?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEbaySellingLimitResp
     */
    checkedAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEbaySellingLimitResp
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEbaySellingLimitResp
     */
    quantityLimit?: number;
    /**
     * QuantityRemaining and AmountRemaining are null without a cap or when remainingError is set.
     * @type {number}
     * @memberof AdminEbaySellingLimitResp
     */
    quantityRemaining?: number;
    /**
     * RemainingError tells why eBay did not say what is left of the limit.
     * @type {string}
     * @memberof AdminEbaySellingLimitResp
     */
    remainingError?: string;
}

export function AdminEbaySellingLimitRespFromJSON(json: any): AdminEbaySellingLimitResp {
    return AdminEbaySellingLimitRespFromJSONTyped(json, false);
}

export function AdminEbaySellingLimitRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminEbaySellingLimitResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amountLimit': !exists(json, 'amountLimit') ? undefined : json['amountLimit'],
        'amountRemaining': !exists(json, 'amountRemaining') ? undefined : json['amountRemaining'],
        'checkedAt': json['checkedAt'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'quantityLimit': !exists(json, 'quantityLimit') ? undefined : json['quantityLimit'],
        'quantityRemaining': !exists(json, 'quantityRemaining') ? undefined : json['quantityRemaining'],
        'remainingError': !exists(json, 'remainingError') ? undefined : json['remainingError'],
    };
}

export function AdminEbaySellingLimitRespToJSON(value?: AdminEbaySellingLimitResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amountLimit': value.amountLimit,
        'amountRemaining': value.amountRemaining,
        'checkedAt': value.checkedAt,
        'currency': value.currency,
        'quantityLimit': value.quantityLimit,
        'quantityRemaining': value.quantityRemaining,
        'remainingError': value.remainingError,
    };
}

